/** @jsxImportSource @emotion/react */
import { Input, useTheme } from '@quickbit/qb-design-system';
import { capitalize, kebabCase } from 'lodash';

export interface DirectOnrampUserDetailsFieldProps {
  fieldName: string;
  value: unknown;
}

export const DirectOnrampUserDetailsField: React.FC<
  DirectOnrampUserDetailsFieldProps
> = ({ fieldName, value }: DirectOnrampUserDetailsFieldProps) => {
  const { palette } = useTheme();

  return (
    <div
      css={{
        '& .MuiInputBase-input.Mui-disabled': {
          WebkitTextFillColor: palette.black,
        },
      }}
    >
      <Input
        label={capitalize(kebabCase(fieldName).replace(/-/g, ' '))}
        value={
          value instanceof Date
            ? value.toLocaleString()
            : value?.toString() ?? ''
        }
        disabled
      />
    </div>
  );
};
